<template>
  <div @click="openDropdown = false">
    <div class="space-y-5">
      <!-- Section header -->
      <div class="flex items-center gap-3">
        <span
          class="flex items-center justify-center w-9 h-9 rounded-lg bg-taxiye-100 text-taxiye-500"
        >
          <span class="material-icons-round">confirmation_number</span>
        </span>
        <h3 class="text-base font-semibold text-gray-800">Tickets</h3>
      </div>

      <!-- Filters -->
      <div class="flex flex-wrap items-center justify-between gap-3">
        <div class="relative w-full max-w-sm">
          <span
            class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none"
          >
            <span class="text-base text-gray-500 material-icons-round"
              >search</span
            >
          </span>
          <input
            v-model="searchKey"
            @keyup="getTickets"
            class="w-full pl-9 text-sm border-gray-300 shadow-sm form-input rounded-xl focus:border-taxiye-300"
            placeholder="Search"
          />
        </div>
        <div class="w-64">
          <select
            class="w-full text-sm border-gray-300 shadow-sm form-select rounded-xl focus:border-taxiye-300"
            @change="setActiveFilter"
          >
            <option :selected="selectedActiveFilter === 'both'" value="both">
              All Status
            </option>
            <option
              :selected="selectedActiveFilter === 'active'"
              value="active"
            >
              Active
            </option>
            <option
              :selected="selectedActiveFilter === 'inactive'"
              value="inactive"
            >
              Inactive
            </option>
          </select>
        </div>
      </div>

      <!-- Table -->
      <div
        class="overflow-hidden bg-white border border-gray-200 shadow-sm rounded-2xl"
      >
        <div class="overflow-x-auto">
          <table class="min-w-full">
            <thead>
              <tr>
                <th
                  class="px-5 py-3 text-xs font-semibold tracking-wider text-left text-gray-500 uppercase bg-gray-50 border-b border-gray-200"
                >
                  Code
                </th>
                <th
                  class="px-5 py-3 text-xs font-semibold tracking-wider text-left text-gray-500 uppercase bg-gray-50 border-b border-gray-200"
                >
                  Employee Name
                </th>
                <th
                  class="px-5 py-3 text-xs font-semibold tracking-wider text-left text-gray-500 uppercase bg-gray-50 border-b border-gray-200"
                >
                  Active
                </th>
                <th
                  class="px-5 py-3 text-xs font-semibold tracking-wider text-left text-gray-500 uppercase bg-gray-50 border-b border-gray-200"
                >
                  Created
                </th>
              </tr>
            </thead>
            <tbody class="relative" v-if="tickets.length">
              <tr
                v-for="ticket in tickets"
                :key="ticket._id"
                class="transition-colors hover:bg-gray-50"
              >
                <td
                  class="px-5 py-4 text-sm font-medium text-gray-800 border-b border-gray-100 whitespace-no-wrap"
                >
                  {{ ticket.code }}
                </td>
                <td
                  class="px-5 py-4 text-sm text-gray-700 border-b border-gray-100 whitespace-no-wrap"
                >
                  {{ ticket.employee ? ticket.employee.name : "" }}
                </td>
                <td class="px-5 py-4 text-sm border-b border-gray-100">
                  <span
                    class="inline-flex items-center px-2.5 py-0.5 text-xs font-medium rounded-full"
                    :class="
                      ticket.active
                        ? 'bg-green-100 text-green-700'
                        : 'bg-gray-100 text-gray-600'
                    "
                  >
                    {{ ticket.active ? "Active" : "Inactive" }}
                  </span>
                </td>
                <td
                  class="px-5 py-4 text-sm text-gray-700 border-b border-gray-100 whitespace-no-wrap"
                >
                  {{ formatDate(ticket.createdAt) }}
                </td>
              </tr>
              <div
                v-if="loading"
                class="absolute inset-0 flex items-center justify-center w-full h-full bg-white bg-opacity-60"
              >
                <span class="text-5xl text-taxiye-500 material-icons-round spin"
                  >sync</span
                >
              </div>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="7" class="px-5 py-12 text-center">
                  <div
                    v-if="loading"
                    class="flex flex-col items-center text-gray-400"
                  >
                    <span class="text-5xl material-icons-round spin">sync</span>
                    <span class="mt-2 text-sm">Loading...</span>
                  </div>
                  <div v-else class="flex flex-col items-center text-gray-400">
                    <span class="text-5xl material-icons-round"
                      >confirmation_number</span
                    >
                    <span class="mt-2 text-sm">No Tickets!</span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="flex items-end justify-between" v-if="!results.length">
        <pagination
          class="flex space-x-2"
          :currentPage="currentPage"
          :total="total"
          @goto="goToPage"
          @setPerPage="setPerPage"
          :perPage="perPage"
          :start="start"
          :end="end"
          :count="paginator.count"
        ></pagination>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import PaginationMixin from "@/mixins/Pagination";
import Pagination from "@/components/Pagination";
// import moment from 'moment';

export default {
  mixins: [PaginationMixin],
  props: ["corporate"],
  data() {
    return {
      allTickets: [],
      employeeName: "",
      openDropdown: false,
      loading: true,
      searchKey: "",
      confirmOpen: false,
      deleting: false,
      results: [],
      selectedActiveFilter: "both",
    };
  },
  components: {
    Pagination,
  },
  created() {
    this.getTickets();
  },
  mounted() {
    document.body.addEventListener("keyup", this.escapeListener);
  },
  beforeDestroy() {
    document.body.removeEventListener("keyup", this.escapeListener);
  },
  watch: {
    corporate() {
      this.getTickets();
    },
    selectedActiveFilter() {
      this.getTickets();
    },
    currentPage() {
      this.getTickets();
    },
    perPage() {
      this.currentPage === 1 ? this.getTickets() : (this.currentPage = 1);
    },
  },
  computed: {
    tickets() {
      return this.results.length ? this.results : this.allTickets;
    },
  },
  methods: {
    setActiveFilter(e) {
      this.selectedActiveFilter = e.target.value;
    },
    escapeListener(e) {
      if (e.keyCode === 27) {
        this.closeConfirmBox();
      }
    },
    formatDate(date) {
      // return moment(date).format("MMM D, YYYY HH:mm");
      return date ? date.replace("T", " ").slice(0, 16) : "-";
    },
    getTickets() {
      let active;

      if (this.selectedActiveFilter === "active") {
        active = true;
      } else if (this.selectedActiveFilter === "inactive") {
        active = false;
      } else {
        active = null;
      }

      this.loading = true;
      this.$misc
        .get(
          `corporates/${
            this.corporate._id
          }/tickets?populate=["employee"]&page=${this.currentPage}${
            this.searchKey ? "&q=" + this.searchKey : ""
          }&limit=${this.perPage}&${active !== null ? "active=" + active : ""}`
        )
        .then(response => {
          this.allTickets = response.data.data;
          this.paginator = {
            nextPage: response.data.nextPage,
            prevPage: response.data.prevPage,
            count: response.data.count,
          };
        })
        .catch(err => console.log(err))
        .finally(() => (this.loading = false));
    },
    toggleDropdown(index) {
      if (this.openDropdown === index) {
        this.openDropdown = false;
      } else {
        this.openDropdown = index;
      }
    },
    // deleteDriver(id) {
    //   this.deleting = true;
    //   this.$misc
    //     .delete(`drivers/${id}`)
    //     .then(result => console.log(result))
    //     .catch(err => console.log(err))
    //     .finally(() => {
    //       this.deleting = false;
    //       this.confirmOpen = false;
    //       this.openDropdown = false;
    //       this.getTickets();
    //     });
    // },
    search: _.debounce(function(e) {
      if (e.target.value.trim() === "") {
        this.results = [];
        return;
      }

      this.$misc
        .get(`/tickets/search?q=${e.target.value}`)
        .then(response => {
          this.results = response.data;
        })
        .catch(err => console.log(err));
    }, 500),
    generateTicket() {
      if (this.employeeName) {
        this.$misc
          .post(`/tickets/generate/${this.$store.state.auth.account._id}`, {
            employeeName: this.employeeName,
          })
          .then(response => {
            this.employeeName = "";
            console.log({ response });
            this.getTickets();
          })
          .catch(err => console.log(err));
      }
    },
  },
};
</script>
